module.exports = __webpack_public_path__ + "static/seedbot-bed3d88b281c307dea61a67f984a2547.png";